import React, { useEffect, useRef, useState } from 'react';
import HeroServices from './HeroServices';
import ServicesSection from './BodyServices';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useLocation } from 'react-router-dom';

const ServicesPage = () => {
  const location = useLocation();
  const [bgColor, setBgColor] = useState('#02044f');

  const sectionRefs = {
    hero: useRef(null),
    airFreight: useRef(null),
    airFreightOffer: useRef(null),
    oceanFreight: useRef(null),
    oceanFreightOffer: useRef(null),
    roadFreight: useRef(null),
    roadFreightOffer: useRef(null),
    warehousing: useRef(null),
    warehousingOffer: useRef(null),
    customs: useRef(null),
    customsOffer: useRef(null),
    footer: useRef(null),
  };

  const sectionOrder = [
    { key: 'hero', color: '#02044f' },
    { key: 'airFreight', color: '#02044f' },
    { key: 'airFreightOffer', color: '#02044f' },
    { key: 'oceanFreight', color: '#86cde9' },
    { key: 'oceanFreightOffer', color: '#86cde9' },
    { key: 'roadFreight', color: '#02044f' },
    { key: 'roadFreightOffer', color: '#02044f' },
    { key: 'warehousing', color: '#86cde9' },
    { key: 'warehousingOffer', color: '#86cde9' },
    { key: 'customs', color: '#02044f' },
    { key: 'customsOffer', color: '#02044f' },
    { key: 'footer', color: '#02044f' },
  ];

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  const interpolateColor = (c1, c2, factor) => {
    return {
      r: Math.round(c1.r + (c2.r - c1.r) * factor),
      g: Math.round(c1.g + (c2.g - c1.g) * factor),
      b: Math.round(c1.b + (c2.b - c1.b) * factor),
    };
  };

  const rgbToHex = ({ r, g, b }) => {
    return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;

      for (let i = 0; i < sectionOrder.length - 1; i++) {
        const ref1 = sectionRefs[sectionOrder[i].key].current;
        const ref2 = sectionRefs[sectionOrder[i + 1].key].current;

        if (!ref1 || !ref2) {
          // console.log(`Missing ref for ${sectionOrder[i].key} or ${sectionOrder[i + 1].key}`);
          continue;
        }

        const nextSectionTop = ref2.offsetTop;
        const nextSectionHeight = ref2.offsetHeight;
        const start = nextSectionTop - viewportHeight * 0.7; // 30% in view
        const end = nextSectionTop; // 100% in view

        if (scrollY >= start && scrollY < end) {
          const progress = (scrollY - start) / (end - start);
          const color1 = hexToRgb(sectionOrder[i].color);
          const color2 = hexToRgb(sectionOrder[i + 1].color);
          const blendedColor = interpolateColor(color1, color2, progress);
          const newColor = rgbToHex(blendedColor);
          setBgColor(newColor);
          // console.log(`Section: ${sectionOrder[i + 1].key}, Color: ${newColor}, Progress: ${progress}`);
          break;
        } else if (scrollY < start && i === 0) {
          // Handle case before first transition
          setBgColor(sectionOrder[0].color);
        } else if (scrollY >= end && i === sectionOrder.length - 2) {
          // Handle case after last section
          setBgColor(sectionOrder[sectionOrder.length - 1].color);
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const headerOffset = 120;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }, 300);
    }
  }, [location]);

  return (
    <div className="relative overflow-hidden">
      <div
        className="fixed inset-0 z-[-1] transition-all duration-800 ease-in-out"
        style={{ backgroundColor: bgColor }}
      />
      <Navbar currentBgColor={bgColor} />
      <div className="relative z-10">
        <div ref={sectionRefs.hero}>
          <HeroServices />
        </div>
        <ServicesSection sectionRefs={sectionRefs} currentBgColor={bgColor} />
        <div ref={sectionRefs.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;